// src/components/Header.js

import React from "react";

const navLinks = [
    { href: "#about", label: "About" },
    { href: "#skills", label: "Skills" },
    { href: "#experience", label: "Experience" },
    { href: "#projects", label: "Projects" },
    { href: "#contact", label: "Contact" },
];

function Header() {
    return (
        <header className="hero" id="top">
            <nav className="nav" aria-label="Primary">
                {navLinks.map((link) => (
                    <a key={link.href} href={link.href}>
                        {link.label}
                    </a>
                ))}
            </nav>
            <p className="hero-eyebrow">Engineering Lead · Full Stack Engineer</p>
            <h1>Augusto Vicente</h1>
            <p className="hero-tagline">
                A decade of experience building products, shipping backend systems and
                leading engineering teams.
            </p>
            <div className="hero-actions">
                <a className="button" href="#contact">
                    Get in touch
                </a>
                <a className="button button-ghost" href="#projects">
                    View projects
                </a>
            </div>
        </header>
    );
}

export default Header;
